import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Warning from "../../../assets/images/icons/warning.svg";
import Input from "../../inputs/inputs";
import Button from "../../buttons/buttons";
import { cleanInput } from "../../../helpers/cleanInput";
import { filterShippers } from "../../../redux/shippers/shippersActions";
import { Beat } from "../../../plugins/spinners.plugin";

export default function FilterShippersDropDown({
  payLoad,
  page,
  isFilterOpen,
  setFilterState,
}) {
  const dispatch = useDispatch();
  const { isLoading, filtering } = useSelector((state) => state.shipper);
  const [errorMsg, setErrorMsg] = useState(false);
  const [data, setData] = useState({
    base_fee: "",
    currency: "",
    city: "",
    discount_percentage: "",
    insurance_percentage: '',
    tax_percentage: ''
  });
  const { base_fee, currency, city, discount_percentage, insurance_percentage, tax_percentage } = data;


  console.log('payLoad', payLoad);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };
  const handleReset = async () => {
    setData({
      base_fee: "",
      currency: "",
      city: "",
      discount_percentage: "",
      insurance_percentage: '',
      tax_percentage: ''
    });
    await dispatch(filterShippers(payLoad, page));
    setFilterState(!isFilterOpen);
  };

  const handleSubmit = async () => {
    cleanInput(data);
    let newData = { ...data, ...payLoad };

    console.log('newData', newData);



    console.log('newData2', newData);
    if (base_fee || currency || city || discount_percentage || insurance_percentage || tax_percentage) {
      setErrorMsg(false);
      try {
        const response = await dispatch(filterShippers({ ...newData }));
        if (response) {
          setFilterState(!isFilterOpen);
        }
      } catch (error) {
        console.log(error);
        setFilterState(!isFilterOpen);
      }
    } else {
      setErrorMsg(true);
    }
  };
  return (
    <>
      <div className="py-5 mt-4 px-5">
        <form className="text-left">
          <div className="grid grid-cols-1">
            <Input.Label
              title={"Base Fee"}
              htmlFor={"base_fee"}
              name={"base_fee"}
              autoComplete="off"
              onChange={handleChange}
              value={base_fee}
              placeholder={"Enter Base Fee E.g 500"}
            />
            <Input.Label
              title={"Discount Percentage"}
              htmlFor={"discount_percentage"}
              name={"discount_percentage"}
              autoComplete="off"
              onChange={handleChange}
              value={discount_percentage}
              placeholder={"Enter Discount Percentage E.g 5"}
            />
            <Input.Label
              title={"Tax Percentage"}
              htmlFor={"tax_percentage"}
              name={"tax_percentage"}
              autoComplete="off"
              onChange={handleChange}
              value={tax_percentage}
              placeholder={"Enter Tax Percentage E.g 5"}
            />
            <Input.Label
              title={"Insurance Percentage"}
              htmlFor={"insurance_percentage"}
              name={"insurance_percentage"}
              autoComplete="off"
              onChange={handleChange}
              value={insurance_percentage}
              placeholder={"Enter Insurance Percentage E.g 5"}
            />
            <Input.Label
              title={"Currency"}
              htmlFor={"currency"}
              name={"currency"}
              autoComplete="off"
              onChange={handleChange}
              value={currency}
              placeholder={"Enter Currency"}
            />

            <Input.Label
              title={"Location"}
              htmlFor={"city"}
              autoComplete="off"
              name={"city"}
              value={city}
              onChange={handleChange}
              placeholder={"Enter City"}
            />

            <div className="py-8 grid grid-cols-2 gap-6 text-center">
              <Button.Secondary
                disabled={isLoading}
                title={isLoading ? <Beat color={"#ce2600"} /> : "Reset"}
                className="px-4"
                onClick={handleReset}
                type="button"
              />
              <Button.Primary
                disabled={filtering}
                title={filtering ? <Beat color={"#ffffff"} /> : "Filter"}
                className="px-4"
                onClick={handleSubmit}
                type="button"
              />
            </div>
          </div>
          {errorMsg && (
            <div className="flex gap-1 -mt-2">
              <img src={Warning} alt="warning" />
              <p>No value to filter by</p>
            </div>
          )}
        </form>
      </div>
    </>
  );
}
